import { render, staticRenderFns } from "./WhatsAppConnect.vue?vue&type=template&id=4877e2a1&scoped=true"
import script from "./WhatsAppConnect.vue?vue&type=script&lang=js"
export * from "./WhatsAppConnect.vue?vue&type=script&lang=js"
import style0 from "./WhatsAppConnect.vue?vue&type=style&index=0&id=4877e2a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4877e2a1",
  null
  
)

export default component.exports